import { useQuery } from 'react-query'

import { QUERY_KEYS } from 'src/constants'
import { scanService } from 'src/services/scan.service'

export const useScanProductImpactWithQuantity = (
  productId: string | null,
  impactId: string | null,
) => {
  return useQuery(
    [QUERY_KEYS.SCAN_PRODUCT_IMPACT, productId, impactId],
    () => scanService.getScanProductImpactWithQuantity(productId || '', impactId || ''),
    {
      keepPreviousData: true,
      enabled: !!productId && !!impactId,
    },
  )
}
